<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['texts']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Link do video',
              modelPath: [this, 'form', 'video_url']
            }),
            new fields.Image({
              label: 'Miniaturka video',
              modelPath: [this, 'form', 'video_overview_image'],
              multilingual: true
            }),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.Input({
              label: 'Podtytuł',
              modelPath: [this, 'form', 'subtitle'],
              multilingual: true
            }),
            new fields.Input({
              label: 'Opis',
              modelPath: [this, 'form', 'description'],
              multilingual: true,
              type: 'textarea'
            }),
            new fields.Header({
              type: 'h3',
              text: 'Wiersze z tekstem'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'texts'],
              items: this.form.texts.map((item, i) => {
                return {
                  headerLabel: get(item, ['text_pl']),
                  fields: [
                    new fields.Input({
                      label: 'Tekst',
                      modelPath: [this, 'form', 'texts', i, 'text'],
                      multilingual: true
                    })
                  ]
                }
              })
            })
          ]
        }
      ]
    }
  }
}
</script>
